// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"7a1b76cda4ffeaf5ceb3","678":"760b2cb9a3749859e168"}[chunkId] + ".js";
};